(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulyshine-collection-explore"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-explore-themes')) {
  customElements.define('ss-explore-themes', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ss-explore__track');
      this.controls = this.querySelector('.ss-explore__controls');
      this.dots = this.querySelector('.ss-explore__dots');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        this.go(button.dataset.page !== undefined ? Number(button.dataset.page) : this.page + Number(button.dataset.direction));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.ss-explore__item');
        const index = [...this.track.children].indexOf(item);
        if (index >= 0) this.go(Math.floor(index / this.columns));
      }, options);
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.track);
      this.layout();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    layout() {
      this.columns = Number(getComputedStyle(this.track).getPropertyValue('--ss-explore-columns'));
      this.pages = Math.ceil(this.track.children.length / this.columns);
      this.controls.hidden = this.pages <= 1;
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i++) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ss-explore__dot'; button.dataset.page = i;
        button.setAttribute('aria-label', `Show collection page ${i + 1} of ${this.pages}`);
        button.setAttribute('aria-controls', this.track.id);
        this.dots.append(button);
      }
      this.update();
    }
    targets() {
      const children = [...this.track.children];
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const step = children.length > 1 ? children[1].offsetLeft - children[0].offsetLeft : this.track.clientWidth;
      return Array.from({length:this.pages}, (_, i) => Math.min(max, i * this.columns * step));
    }
    update() {
      const targets = this.targets();
      this.page = targets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(targets[best] - this.track.scrollLeft) ? i : best, 0);
      [...this.dots.children].forEach((button, i) => button.setAttribute('aria-current', String(i === this.page)));
      this.controls.querySelector('[data-direction="-1"]').disabled = this.page === 0;
      this.controls.querySelector('[data-direction="1"]').disabled = this.page >= this.pages - 1;
    }
    go(page) {
      const target = this.targets()[Math.max(0, Math.min(page, this.pages - 1))];
      this.track.scrollTo({ left:target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulyshine-explore-themes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-explore-themes')) {
  customElements.define('ss-explore-themes', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ss-explore__track');
      this.controls = this.querySelector('.ss-explore__controls');
      this.dots = this.querySelector('.ss-explore__dots');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        this.go(button.dataset.page !== undefined ? Number(button.dataset.page) : this.page + Number(button.dataset.direction));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.ss-explore__item');
        const index = [...this.track.children].indexOf(item);
        if (index >= 0) this.go(Math.floor(index / this.columns));
      }, options);
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.track);
      this.layout();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    layout() {
      this.columns = Number(getComputedStyle(this.track).getPropertyValue('--ss-explore-columns'));
      this.pages = Math.ceil(this.track.children.length / this.columns);
      this.controls.hidden = this.pages <= 1;
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i++) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ss-explore__dot'; button.dataset.page = i;
        button.setAttribute('aria-label', `Show collection page ${i + 1} of ${this.pages}`);
        button.setAttribute('aria-controls', this.track.id);
        this.dots.append(button);
      }
      this.update();
    }
    targets() {
      const children = [...this.track.children];
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const step = children.length > 1 ? children[1].offsetLeft - children[0].offsetLeft : this.track.clientWidth;
      return Array.from({length:this.pages}, (_, i) => Math.min(max, i * this.columns * step));
    }
    update() {
      const targets = this.targets();
      this.page = targets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(targets[best] - this.track.scrollLeft) ? i : best, 0);
      [...this.dots.children].forEach((button, i) => button.setAttribute('aria-current', String(i === this.page)));
      this.controls.querySelector('[data-direction="-1"]').disabled = this.page === 0;
      this.controls.querySelector('[data-direction="1"]').disabled = this.page >= this.pages - 1;
    }
    go(page) {
      const target = this.targets()[Math.max(0, Math.min(page, this.pages - 1))];
      this.track.scrollTo({ left:target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulyshine-jewelry-themes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-explore-themes')) {
  customElements.define('ss-explore-themes', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ss-explore__track');
      this.controls = this.querySelector('.ss-explore__controls');
      this.dots = this.querySelector('.ss-explore__dots');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        this.go(button.dataset.page !== undefined ? Number(button.dataset.page) : this.page + Number(button.dataset.direction));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.ss-explore__item');
        const index = [...this.track.children].indexOf(item);
        if (index >= 0) this.go(Math.floor(index / this.columns));
      }, options);
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.track);
      this.layout();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    layout() {
      this.columns = Number(getComputedStyle(this.track).getPropertyValue('--ss-explore-columns'));
      this.pages = Math.ceil(this.track.children.length / this.columns);
      this.controls.hidden = this.pages <= 1;
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i++) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ss-explore__dot'; button.dataset.page = i;
        button.setAttribute('aria-label', `Show collection page ${i + 1} of ${this.pages}`);
        button.setAttribute('aria-controls', this.track.id);
        this.dots.append(button);
      }
      this.update();
    }
    targets() {
      const children = [...this.track.children];
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const step = children.length > 1 ? children[1].offsetLeft - children[0].offsetLeft : this.track.clientWidth;
      return Array.from({length:this.pages}, (_, i) => Math.min(max, i * this.columns * step));
    }
    update() {
      const targets = this.targets();
      this.page = targets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(targets[best] - this.track.scrollLeft) ? i : best, 0);
      [...this.dots.children].forEach((button, i) => button.setAttribute('aria-current', String(i === this.page)));
      this.controls.querySelector('[data-direction="-1"]').disabled = this.page === 0;
      this.controls.querySelector('[data-direction="1"]').disabled = this.page >= this.pages - 1;
    }
    go(page) {
      const target = this.targets()[Math.max(0, Math.min(page, this.pages - 1))];
      this.track.scrollTo({ left:target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
